import { useCallback } from 'react';
import { copyText, invitationMessage, invitationUrl, shareInvitation, type Invitation } from './invitation';

type Notify = (tone: 'success' | 'info' | 'error', text: string) => void;

/**
 * What the invitation panel does, shared by the guide's and the signatory's screens: the link to share, the last day it works,
 * and the two actions. `fallbackAppUrl` is the passengers' site as the browser knows it, for a server without one configured.
 */
export function useInvitationSharing(invitation: Invitation | undefined, fallbackAppUrl: string, notify: Notify) {
  const url = invitation === undefined ? null : invitationUrl(invitation, fallbackAppUrl);
  const closesAt = invitation?.closesAt ?? undefined;
  const closesOnText =
    closesAt === undefined ? undefined : new Date(closesAt).toLocaleDateString('es', { day: 'numeric', month: 'long' });
  const share = useCallback((): void => {
    if (url === null || invitation === undefined) return;
    void shareInvitation(url, invitationMessage(invitation.groupName)).then((outcome) => {
      if (outcome === 'shared') notify('success', 'Enlace compartido.');
    });
  }, [url, invitation, notify]);
  const copy = useCallback((): void => {
    if (url === null) return;
    void copyText(url).then((copied) => {
      notify(
        copied ? 'success' : 'error',
        copied ? 'Enlace copiado.' : 'No pudimos copiarlo. Probá con «Compartir por WhatsApp».',
      );
    });
  }, [url, notify]);
  return { url, closesOnText, share, copy } as const;
}
